<template>
    <v-dialog
        v-model="dialogActive"
        persistent
        max-width="500"
    >
        <v-card>
            <v-card-text>
                <v-container v-if="!dialogLoading">
                    <v-alert type="error">
                        <h2>Confirmar Exclusão</h2>
                    </v-alert>
                    <p class="ml-4 confirm-text">
                        Você realmente deseja excluir <span class="font-weight-bold text-uppercase">{{ entityToDelete }}</span>?
                    </p>
                </v-container>
                <v-row
                    class="pa-10"
                    align-content="center"
                    justify="center"
                    v-else
                >
                    <v-col
                        class="subtitle-1 text-center"
                        cols="12"
                    >
                        Excluindo... Aguarde.
                    </v-col>
                    <v-col cols="8">
                        <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="12"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions v-if="!dialogLoading">
                <v-btn text @click="$emit('close-dialog')">
                    Cancelar
                </v-btn>
                <v-btn color="error" @click="$emit('delete-method')">
                    Excluir
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ConfirmDeletionModal",
    props: [
        'dialogActive',
        'dialogLoading',
        'entityToDelete',
    ],
}
</script>

<style scoped>
.v-dialog .v-card__text, .container {
    padding: 0 !important;
}

.v-dialog .v-alert {
    border-radius: 0 !important;
}

.v-dialog, .v-dialog .v-card__text {
    overflow: hidden !important;
}

.v-card__actions {
    justify-content: flex-end;
}

.confirm-text {
    font-size: 16px;
}
</style>
